module.exports = __webpack_public_path__ + "static/media/OutliersQ7_5.5dfb3a28.svg";